import { SkillScoreStatus } from '../../../models/skill-learning.model';
import { LearningGradeSettings } from 'app/models/general-setting.model';

export abstract class ScoreStatusInput {
  learningGradeSettings?: LearningGradeSettings | null;
  abstract checkPeriodMonths: number;
  abstract status: SkillScoreStatus;
  abstract activePoints: number;
  abstract nextDeadline: string;
}

export const SCORE_GRADE_CATEGORIES = ['MANDATORY', 'OWN_DEPARTMENT', 'OTHER_DEPARTMENT'];
export const SCORE_GRADE_LEVELS = [0, 1, 2];
export const SCORE_HELP_TOPICS = ['MANDATORY', 'DEPARTMENT', 'OPTIONAL', 'LEVELS', 'GRADE', 'PROBATION'];



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/skill-learning/components/user/learning-tree/learning-score-status-widget.option.ts